import { call, put, takeEvery } from 'redux-saga/effects';
import i18next from "i18next";
import * as actionTypes from '../../../constants/ActionTypes/AdminPortal/FeatureSwitch';
import { _CALLGETAPI } from '../../../api/apiHandler'
import { _ADMINISTRATOR_API_ENDPOINTS } from '../../../constants/AppConstants';

function _FETCHCOUNTRYFEATURELIST(countryCode){
    const endpoint = _ADMINISTRATOR_API_ENDPOINTS.FEATURE_SWITCH_BY_COUNTRY;
    
    const payload = {
        params: {
            countryCode: countryCode
        }
      }
     return _CALLGETAPI(endpoint, payload)
    .then(response => {
        return response;
    })
    .catch((error) => {
        throw error;
    });
}

function* handleInfo(action){
    try {
        const countryCode = action.countryCode;
        if(countryCode){
            const result = yield call(_FETCHCOUNTRYFEATURELIST, countryCode);
            if(Object.values(result).length > 0) {
                yield put({type: actionTypes.MANAGE_FEATURE_SWITCH_BY_COUNTRY_SUCCESS, data: result});
            } else {
                yield put({
                    type: actionTypes.MANAGE_FEATURE_SWITCH_BY_COUNTRY_ERROR, 
                    message: i18next.t('Admintranslation:ADMIN_COMMON_ERRORS.NO_RECORDS_FOUND')
                });
            }
        } else {
            yield put({
                type: actionTypes.MANAGE_FEATURE_SWITCH_BY_COUNTRY_ERROR, 
                message: i18next.t('Admintranslation:ADMIN_COMMON_ERRORS.INVALID_INPUT')
            });
        }
    } catch (e) {
         yield put({type: actionTypes.MANAGE_FEATURE_SWITCH_BY_COUNTRY_ERROR, message: i18next.t('Admintranslation:ADMIN_COMMON_ERRORS.TECHNICAL_ERROR')});
    }
}

function* FeatureSwitchCountry(){
    yield takeEvery(actionTypes.MANAGE_FEATURE_SWITCH_BY_COUNTRY_INIT, handleInfo);
}

export default FeatureSwitchCountry;